<template>
    <div class="container mx-auto flex justify-center py-10"
        v-if="hasUser()">
      <div class="w-full md:w-70-p lg:px-12 xl:px-16">
      <div
        class="py-12 bg-center bg-no-repeat bg-cover sm:bg-contain rounded"
        style="background-image: url('/storage/image/banner-profile-subscribe.webp')"
      >
        <div class="container mx-auto flex flex-col items-center justify-center px-4">
          <div class="text-jblue-primary font-shadow-sm font-extrabold text-2xl mb-2 text-center">{{ jw ? $t('messages.general.subscribe_jw') : $t('messages.general.subscribe_today')}}</div>
          <p class="text-jblue-secondary font-shadow-sm font-bold text-base w-2/3 mx-auto mb-4 text-center">{{ $t('messages.general.subscribe_message_mini')}}</p>
          <router-link
            class="mx-auto bg-jblue-primary text-white hover:text-jblue-primary font-semibold rounded py-1 px-4 block text-center text-base hover:bg-white border border-jblue-primary shadow-lg"
            :style="{visibility: hideButton ? 'hidden' : 'visible'}"
            to="/subscriptions"
            rel="nofollow"
          >{{ jw ? $t('messages.general.subscribe_button_jw') : $t('messages.general.subscribe') }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import get from 'lodash/get';

export default {
  name: "BannerSubscribeInline",
  props: {
    guestMode: Boolean,
    hideButton: {
      type: Boolean,
      default: false
    },
    jw: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState("auth", ["user"])
  },
  methods: {
    hasUser() {
      if (get(this.user, 'id', 0) > 0) {
        return (this.user.subscription_status !== 'active' || this.user.with_gift);
      } else {
        return true;
      }
    },
  }
};
</script>

<style scoped lang="scss">

.font-shadow-sm {
  text-shadow: 0px 1px 2px rgba(0,0,0,0.2);
}

.md\:w-70-p {
  @media only screen and (min-width: 768px) {
    width: 77%;
  }
}
</style>
